
jQuery(function($) {

	$('#posts_loadmore').click(function(event){

		event.preventDefault();

		$.ajax({
			url : news_loadmore_params.ajaxurl,
			data : {
				'action': 'postloadmore',
				'query': news_loadmore_params.posts,
				'page' : news_loadmore_params.current_page 
			},
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#posts_loadmore').text('Loading...');
			},
			success : function( posts ){
				if( posts ) {

					// $('.postpage__wrapper').empty();
					$('#posts_loadmore').text( 'Load More' );
					$('#postpage__results').append( posts );
					news_loadmore_params.current_page++;

					if ( news_loadmore_params.current_page == news_loadmore_params.max_page ){
						$('.postpage__loadmore').hide();
					}

				} else {
					$('.postpage__loadmore').hide();
				}
			}
		});
		return false;
	});

	/*
	* Filter
	*/
	$('#filter_posts').submit(function(event){

		event.preventDefault();
		console.log('filter');

		var search = $('input[name="s"]').val();
		var category = $('#category-select').val();

		console.log(category);

		if (search === '' && category === '') {
			location.reload();
			return;
		}

		$.ajax({
			url : news_loadmore_params.ajaxurl,
			data : $('#filter_posts').serialize(),
			dataType : 'json',
			type : 'POST',
			beforeSend : function(xhr){
				// $('#filter_posts').find('button').text('Filtering...');
			},
			success : function( data ){

				console.log(data);

				$('.postpage__list').empty();
				news_loadmore_params.current_page = 1;
				news_loadmore_params.posts = data.posts;
				news_loadmore_params.max_page = data.max_page;
				$('#postpage__results').html(data.content);

				if ( data.max_page < 2 ) {
					$('.postpage__loadmore').hide();
				} else {
					$('.postpage__loadmore').show();
				}
			}
		});
		return false;

	});


});
